import {Enumeration} from './model/enumeration.model';

export class State implements Enumeration {

  private static ALL_VALUES: { [name: string]: State } = {};

  public static readonly IN_PROGRESS = new State(0, 'in progress');
  public static readonly WAIT = new State(1, 'wait');
  public static readonly COMPLETED = new State(2, 'completed');
  public static readonly ABORTED = new State(3, 'aborted');
  public static readonly CANCELED = new State(4, 'canceled');
  public static readonly EXPIRED = new State(5, 'expired');
  public static readonly FAILED = new State(6, 'failed');
  public static readonly IDLE = new State(7, 'idle');
  public static readonly ACCEPTED = new State(8, 'accepted');
  public static readonly REJECTED = new State(9, 'rejected');

  private constructor(readonly id: number, readonly name: string) {
    State.ALL_VALUES[id] = this;
  }
}
